import { render, staticRenderFns } from "./AccompanyStudy.vue?vue&type=template&id=6964e1a6&scoped=true&"
import script from "./AccompanyStudy.vue?vue&type=script&lang=js&"
export * from "./AccompanyStudy.vue?vue&type=script&lang=js&"
import style0 from "./AccompanyStudy.vue?vue&type=style&index=0&id=6964e1a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964e1a6",
  null
  
)

export default component.exports